import React from "react";
import { Link, graphql } from "gatsby";

const Footer = ({ pathname, dates, links }) => {
  const footerLinks = links || [];

  return (
    <footer className="Footer">
      <div className="Footer__Nav">
        <p className="Footer__Logo">Tech week</p>
        <ul className="Footer__Links Footer__Links__Home">
          {footerLinks.map((link, i) => (
            <li className="Footer__Link" data-is-link key={i}>
              {link.is_external ? (
                <a
                  className="Footer__LinkLabel"
                  href={link.url}
                  target="_blank"
                  rel="noreferrer"
                >
                  {link.label}
                </a>
              ) : (
                <Link to={link.url} className="Footer__LinkLabel">
                  {link.label}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>
      <div className="Footer__Content">
        <div className="Footer__ContentLeft"></div>
        <div className="Footer__ContentRight">{dates.text}</div>
      </div>
    </footer>
  );
};

export default Footer;

export const query = graphql`
  fragment Footer on PrismicFooter {
    data {
      dates {
        text
      }
      links {
        label
        url
        is_external
      }
    }
  }
`;
